import { render, staticRenderFns } from "./SpecializationAvatar.vue?vue&type=template&id=ad3b01c8&scoped=true"
import script from "./SpecializationAvatar.vue?vue&type=script&lang=js"
export * from "./SpecializationAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3b01c8",
  null
  
)

export default component.exports